import React, { Component } from 'react';

import Select from 'react-select';
import { getCustomSelectStyles } from '_utils';
import { Translate, translateKey } from '_translations';

class Filters extends Component {
  render() {
    return (
      <header className="leaderboard__search-filter">
        <div className="form-input-container">
          <input type="search" name="search" className="form-input form-input--search" value={this.props.searchTerm} onChange={this.props.handleSearchChange} />
          {this.props.searchTerm.length === 0 &&
            (
              <label htmlFor="search" className="form-label">
                <span className="svg svg--search"></span>
                <Translate resourceString="Thunderbolt.Leaderboard.SearchPlaceholder" renderAsHtml={true}/>
              </label>
            )
          }
        </div>

        <div className="form-input-container">
          <Select
            options={this.getCountriesFromEntries()}
            styles={getCustomSelectStyles({ control: { border: 'none !important' } })}
            isClearable={true}
            placeholder={<div className="country-placeholder"><Translate resourceString="Thunderbolt.Leaderboard.FilterPlaceholder" renderAsHtml={true}/></div>}
            onChange={this.props.handleCountrySelected}
            value={this.props.selectedCountry}>
          </Select>
        </div>
      </header>
    );
  }

  // eslint-disable-next-line
  getCountriesFromEntries = () => {
    const filters = [
      { label: translateKey('Thunderbolt.Leaderboard.Finalists'), value: '(top_per_region)' },
    ];

    const cultures = this.props.leaderboard.content.cultureOptions.map(x => ({
      label: x.cultureName,
      value: x.cultureCode,
    }));

    return filters.concat(cultures);
  }
}

export default Filters;
